import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import { Accordion } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import classes from '../../css/item.module.css';


const AccordionComp = (props) => {

    const accordion = props.items;
    const items = accordion.map((item) => (
        <Accordion.Item key={item.value} value={item.value} >
            <Accordion.Control >{item.value}</Accordion.Control>
            <Accordion.Panel><p style={{ padding: '0px 13px 13px 13px', maxWidth: '1000px' }}>{item.description}</p></Accordion.Panel>
        </Accordion.Item>
    ));

    return (
        <>



            <div className='accord-container'>
                <div style={{ marginBottom: '50px' }} className='home-text-wrapper'>
                    {
                        props.title ?
                            props.title
                            : null
                    }
                    <div className='hero-center'>

                        {
                            props.description ?
                                <p style={{ maxWidth: '477px', color: 'white' }}>{props.description}</p>
                                : null
                        }
                    </div>




                </div>
                <Accordion classNames={{ chevron: classes.chevron }}
                    chevron={<div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }} className={classes.icon}><i style={{ fontSize: '35px', color: 'var(--main-color)' }} className='material-icons-rounded'>add</i></div>} variant="contained" defaultValue="Apples">
                    {items}

                </Accordion>
            </div>

        </>
    );
};

export default AccordionComp;
